import React, { useState } from 'react';

type tabType = {
  label: string;
  value: any;
};

export default function Tabs({
  items,
  handleFilterClick,
}: {
  items: Array<tabType>;
  handleFilterClick: any;
}) {
  const [activeTab, setActiveTab] = useState(0);
  const [isActive, setIsActive] = useState(false);

  const onHandleClick = (e, value) => {
    const curTab = parseInt(e.currentTarget.dataset.index);
    setActiveTab(curTab);
    setIsActive(!isActive);
    handleFilterClick(value);
  };

  return (
    <ul className={`tabs ${isActive ? 'tabs--switch' : ''}`}>
      {items.map((item, i) => (
        <li
          key={i}
          className={`tabs__item ${activeTab == i ? 'tabs__item--active' : ''}`}
          data-index={i}
          onClick={(event) => onHandleClick(event, item.value)}
        >
          <span className="tabs__item-content">{item.label}</span>
        </li>
      ))}
    </ul>
  );
}
